import axios from 'axios';
import Configs from '../config';


function getTable(table) {
    return axios.post(`${Configs.apiUrl}/masterData/get`, { table });
}

function getTables(tables) {
    return axios.post(`${Configs.apiUrl}/masterData/getMany`, { tables });
}

function add(table, data) {
    return axios.post(`${Configs.apiUrl}/masterData/add`, { table, data });
}

function updateCol(table, rowId, col, val) {
    return axios.put(`${Configs.apiUrl}/masterData/updateCol`, { table, rowId, col, val });
}

function deleteRow(table, rowId) {
    return axios.delete(`${Configs.apiUrl}/masterData/deleteRow/${table}/${rowId}`);
}


/**
 * Exports
 */
const MasterDataService = {
    getTable,
    getTables,
    add,
    updateCol,
    deleteRow
}
export default MasterDataService;